export default __webpack_public_path__ + "static/Dunbar-Tall-Extra-Light-68a9461272dad59c31b40599c5809126.ttf";